import Identified from "@mapmycustomers/shared/types/base/Identified";
import Named from "@mapmycustomers/shared/types/base/Named";

const defaultSelectOptionMapper = (entity: Identified & Named) => ({
  label: entity.name,
  value: entity.id,
});

export default defaultSelectOptionMapper;
